import { render, staticRenderFns } from "./BaseDeTrabajadores.vue?vue&type=template&id=1b7a0d0a&scoped=true&"
import script from "./BaseDeTrabajadores.vue?vue&type=script&lang=js&"
export * from "./BaseDeTrabajadores.vue?vue&type=script&lang=js&"
import style0 from "./BaseDeTrabajadores.vue?vue&type=style&index=0&id=1b7a0d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a0d0a",
  null
  
)

export default component.exports